import { configReducer } from '@library/store/config/config.reducer';
import { HomesActions } from '@library/store/homes/homes.action';
import { HomesReducers } from '@library/store/homes/homes.reducer';
import { langsReducer } from '@library/store/lang/lang.reducers';
import { ModulesReducers } from '@library/store/modules/modules.reducer';
import { EnumPageLoaderActions, PageLoaderActions } from '@library/store/page-loader/page-loader.actions';
import { roomsReducer } from '@library/store/rooms/rooms.reducer';
import { userReducer } from '@library/store/user/user.reducer';
import { reduceReducers } from '@library/utils/helpers/store/reduce-reducers';
import { ActionReducerMap } from '@ngrx/store';
import { AppState } from './app.state';
import { HomesVeluxReducers } from './homes/homes.reducer';
import { HomesStateVelux, initialHomesStateVelux } from './homes/homes.state';
import { SchedulesVeluxReducers } from './schedules/schedules.reducer';

export function isPageLoading(state = true, action: PageLoaderActions): boolean {
  switch (action.type) {
    case EnumPageLoaderActions.ShowPageLoader: return true;
    case EnumPageLoaderActions.HidePageLoader: return false;
    default: return state;
  }
}

export function HomesReducersReduced(state = initialHomesStateVelux, action: HomesActions): HomesStateVelux {
  const reducer = reduceReducers(initialHomesStateVelux, HomesReducers, HomesVeluxReducers);
  return reducer(state, action);
}

export const AppReducers: ActionReducerMap<AppState> = {
  config: configReducer,
  user: userReducer,
  langs: langsReducer,
  rooms: roomsReducer,
  homes: HomesReducersReduced,
  modules: ModulesReducers,
  schedules: SchedulesVeluxReducers,
  isPageLoading,
};
